import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when user focuses transcript search input field',
  name: 'clicked_transcript_search',
  params: [
    {
      description: 'The ID of clip',
      name: 'clip_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
